import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { useDeleteProfile } from "shared/lib/useDeleteProfile"
import { useEvent } from "shared/lib/useEvent"

import { ProfileDeleteCodeFormData } from "../ui/ProfileDeleteCodeOverlayView"
import { UseProfileDeleteCodeOverlayViewModelProps } from "./useProfileDeleteCodeOverlayViewModel"

export function useProfileDeleteSubmitCodeOverlayModel(): UseProfileDeleteCodeOverlayViewModelProps {
  const { closeOverlay } = useCurrentOverlay()
  const {
    remainingAttempts,
    submitCode,
    verifyCode,
    isVerifying,
    isCodeCorrect
  } = useDeleteProfile()

  const handleVerify = useEvent((formData: ProfileDeleteCodeFormData) => {
    return verifyCode(formData.code)
  })

  const handleSubmit = useEvent((formData: ProfileDeleteCodeFormData) => {
    return submitCode(formData.code).then(success => {
      if (success) {
        closeOverlay()
      }
      return success
    })
  })

  return {
    remainingAttempts,
    isVerifying,
    isCodeCorrect,
    verifyCode: handleVerify,
    onSubmit: handleSubmit
  }
}
